<app-pan-button color="danger" icon="warning" (click)="onReportProblemClick()" data-testid="reportAProblem">
  Report a problem
</app-pan-button>

<app-pan-modal #modal modalId="errorForm" cancelTitle="Close" headerClass="bg-danger">
  <div header>File an error report</div>

  <div body class="block px-4">
    @if (isLoadingData()) {
      <p role="status">Loading problem reasons...</p>
    }
    @if (loadError()) {
      <app-pan-inline-alert type="danger" data-testid="problem-reasons-load-error">
        Failed to load problem reasons: {{ loadError() }} You can still use Other.
      </app-pan-inline-alert>
      <app-pan-button icon="refresh" (click)="refresh()">Retry</app-pan-button>
    }
    <ul class="w-full text-sm font-medium text-gray-900">
      @for (re of reviewErrorTypes(); track re.id) {
        <li class="w-full border-gray-200 sm:border-r p-2 flex gap-2">
          <label class="relative flex-auto">
            <input
              type="checkbox"
              panCheckbox
              [disabled]="isLoadingData()"
              (change)="updateSelection(re.id, $event)"
              [checked]="this.selectedErrorTypeIds().includes(re.id)"
              [attr.data-testid]="re.id"
            />
            <span>
              {{ re.label }}
            </span>
          </label>
        </li>
      }
    </ul>

    <form [formGroup]="form">
      <div class="flex flex-col">
        <div class="px-4 py-6 self-center w-full" [class.hidden]="!commentsRequired()">
          <label class="block mb-2 text-sm font-medium text-gray-900" for="error-comments">
            Comments {{ commentsRequired() ? "(required)" : "" }}
          </label>
          <textarea
            panTextarea
            id="error-comments"
            formControlName="comments"
            placeholder="Describe your problem here, be as specific and detailed as you can. Copy any error messages you see as is."
            rows="10"
          ></textarea>
        </div>
      </div>
    </form>
  </div>

  <div footer>
    <app-pan-button color="primary" (click)="onSubmit()" [disabled]="!isErrorFormValid()" data-testid="errorModalSubmit" panModalClose>
      Submit
    </app-pan-button>
    <app-pan-button panModalClose>Cancel</app-pan-button>
  </div>
</app-pan-modal>

<swal
  #reportProblemSuccess
  title="Problem reported 🔥"
  text="Thank you for reporting a problem with this review!"
  icon="success"
  [showCancelButton]="false"
  (confirm)="redirectDashboard()"
  confirmButtonText="Go to dashboard"
></swal>
